import { render, staticRenderFns } from "./SettingsBase.vue?vue&type=template&id=1770d788&scoped=true&"
import script from "./SettingsBase.vue?vue&type=script&lang=ts&"
export * from "./SettingsBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770d788",
  null
  
)

export default component.exports